import { forwardRef } from 'react'

const Button = forwardRef(({ 
  children, 
  variant = 'primary', 
  type = 'button',
  disabled = false,
  className = '',
  as = 'button',
  loading, // strip non-DOM prop to avoid React warning
  isLoading, // alias
  ...props 
}, ref) => {
  const baseClasses = variant === 'primary' ? 'btn-primary' : 'btn-secondary'
  const Component = as
  
  // Only include type prop for actual button elements
  const restProps = { ...props }
  // Ensure "loading" is not forwarded to DOM
  delete restProps.loading
  delete restProps.isLoading
  const busy = Boolean(loading ?? isLoading)
  const componentProps = Component === 'button' 
    ? { type, disabled, 'aria-busy': busy || undefined, ...restProps }
    : { 'aria-busy': busy || undefined, ...restProps }
  
  return (
    <Component
      ref={ref}
      className={`${baseClasses} ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      {...componentProps}
    >
      {children}
    </Component>
  )
})

Button.displayName = 'Button'

export default Button


